export const interpretAttr = (key, value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  const valStr = String(value).toLowerCase();
  switch (key) {
    case "pets":
      return valStr === "1"
        ? "Yes"
        : valStr === "10" || valStr === "0"
          ? "No"
          : "N/A";
    case "furnishing":
      if (valStr === "1") return "Furnished";
      if (valStr === "2") return "Unfurnished";
      if (valStr === "3") return "Partly";
      return "N/A";
    case "parking":
      return valStr === "1"
        ? "Yes"
        : valStr === "10" || valStr === "0"
          ? "No"
          : "N/A";
    case "online-viewing":
      return valStr === "1"
        ? "Yes"
        : valStr === "10" || valStr === "0"
          ? "No"
          : "N/A";
    case "construction-year":
      const yearNum = parseInt(valStr);
      if (!isNaN(yearNum)) {
        if (yearNum >= 0 && yearNum <= 99)
          return yearNum < 30
            ? `20${String(yearNum).padStart(2, "0")}`
            : `19${String(yearNum).padStart(2, "0")}`;
        return valStr;
      }
      return "N/A";
    default:
      return valStr;
  }
};

export const findSimilarProperties = (targetProperty, properties) => {
  if (!targetProperty || !properties.length) return [];

  const targetPrice = targetProperty.price || targetProperty.lastKnownPrice || 0;
  const targetBedrooms = parseInt(targetProperty.bedrooms) || 0;
  const targetArea = parseInt(targetProperty.area) || 0;

  return properties
    .filter(p =>
      p.id !== targetProperty.id &&
      !p.deleted &&
      Number(p.price || p.lastKnownPrice) !== 0
    )
    .map(p => {
      let score = 0;

      // Price similarity (within 30%)
      const propertyPrice = p.price || p.lastKnownPrice || 0;
      const priceDiff = Math.abs(propertyPrice - targetPrice) / targetPrice;
      if (priceDiff <= 0.3) score += 40;
      else if (priceDiff <= 0.5) score += 20;

      // Bedroom similarity
      const pBedrooms = parseInt(p.bedrooms) || 0;
      if (pBedrooms === targetBedrooms) score += 30;
      else if (Math.abs(pBedrooms - targetBedrooms) === 1) score += 15;

      // Area similarity (within 25%)
      const pArea = parseInt(p.area) || 0;
      if (targetArea > 0 && pArea > 0) {
        const areaDiff = Math.abs(pArea - targetArea) / targetArea;
        if (areaDiff <= 0.25) score += 20;
        else if (areaDiff <= 0.5) score += 10;
      }

      // Location similarity (same city)
      if (p.cityId && targetProperty.cityId && p.cityId === targetProperty.cityId) {
        score += 10;
      }

      return { ...p, similarityScore: score };
    })
    .filter(p => p.similarityScore >= 30)
    .sort((a, b) => b.similarityScore - a.similarityScore)
    .slice(0, 5);
};